module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/detail-bg-496ad06da042b32966f12e7fa65e9cc2.svg";